import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject, asyncScheduler } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoreMenuService } from 'src/@core/components/core-menu/core-menu.service';
import { CoreConfigService } from 'src/@core/services/config.service';
import { observeOn } from 'rxjs/operators';

@Component({
  selector: 'horizontal-layout',
  templateUrl: './horizontal-layout.component.html',
  styleUrls: ['./horizontal-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HorizontalLayoutComponent implements OnInit, OnDestroy {
  coreConfig: any;
  currentMenu: string = '';

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _coreMenuServ: CoreMenuService
  ) {
    this.coreConfig = this._coreConfigService.defaultConfig;

    _coreMenuServ.onMenuChanged.subscribe((v) => {
      this.currentMenu = v;
    });
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config
      .pipe(observeOn(asyncScheduler))
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.coreConfig = config;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
